export const deactivatedUserSx = {
  color: 'text.disabled',
} as const;
